import React from 'react';
import { Col, FormGroup } from 'react-bootstrap';

export const Form = ({ action, children, submitText }) => (
	<Col className="form-column" md={7} sm={12} xs={12}>
		<div className="column-inner">
			<div className="contact-form">
				<form method="post" action={action} id="contact-form">

					{children}

					<FormGroup>
						<button className="theme-btn btn-style-seven" type="submit"
						        name="submit-form">{submitText}</button>
					</FormGroup>

				</form>
			</div>
		</div>
	</Col>
);



// WEBPACK FOOTER //
// ./src/components/ui/Contact/Form.js